// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/ellipsis.js';

import { paths } from '../generated/ellipsis';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('ellipsis', Original, paths);
